jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });


  var count = 0;
  var $form = '';
  $(document).on("submit", ".t4s-cartPage__form, .t4s-drawer__wrap", function(event){
    if (count !== -1){
      event.preventDefault();
      event.stopPropagation();
    }
    if (count == 0){
      $('body').addClass('opend-pre-checkout');
      setTimeout(function() {$('body').addClass('opended-pre-checkout');}, 500)
      $form = $(this);
    }
    if (count !== -1){
      ++count;
    }
  })
  $(document).on("click", ".opended-pre-checkout .overlay-pre-checkout, .pre-checkout-popup .btn-close", function(event){
    count = -1;
    $form.find('.t4s-btn__checkout').trigger( "click" );
  })
  $(document).on("click", ".pre-checkout-popup .t4s-pr-addtocart", function(event){
    $(this).parents('.t4s-product').addClass('pre-checkout-loading');
  })
  window.productPreAdded = function(event) {
    $(".opended-pre-checkout .pre-checkout-loading").append('<div class="product-pre-added"><span>Added</span></div>');
    setTimeout(function() {$(".opended-pre-checkout .pre-checkout-loading").hide();setTimeout(function() {$(".opended-pre-checkout .pre-checkout-loading").remove();}, 5000);}, 2000);
    
  }
});